import { LDUser } from 'launchdarkly-js-client-sdk';
import { VERTICAL_NAME } from 'app/shared/consts/vertical-name';
import { useMemo } from 'react';
import { useApi } from 'app/shared/contexts/api';
import { useBuilding } from 'app/shared/contexts/building';
import { useUser } from 'app/shared/contexts/user';

interface WebTrackingData {
  currentUser: LDUser;
  buildingUuid: string;
  appUuid: string;
  clientApiUrl: string;
  authToken: string;
}

export const useWebTrackingAnalytics = (): WebTrackingData | null => {
  const { building } = useBuilding();
  const { user } = useUser();
  const { apiUrl: clientApiUrl, authToken } = useApi();

  return useMemo(() => {
    if (!building || !user) {
      return null;
    }
    return {
      currentUser: { key: user.uuid, email: user.email },
      buildingUuid: building.uuid,
      appUuid: VERTICAL_NAME,
      clientApiUrl,
      authToken,
    };
  }, [building, user, clientApiUrl, authToken]);
};
